import validate from "/Users/sebasgona/sga/pinturas-granados/granados/node_modules/.pnpm/nuxt@3.20.2_@parcel+watcher@2.5.1_@types+node@25.0.2_@vue+compiler-sfc@3.5.25_cac@6.7.14_db0@_cvukev6a3n62iehx3yqgnlmtcy/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/Users/sebasgona/sga/pinturas-granados/granados/node_modules/.pnpm/nuxt@3.20.2_@parcel+watcher@2.5.1_@types+node@25.0.2_@vue+compiler-sfc@3.5.25_cac@6.7.14_db0@_cvukev6a3n62iehx3yqgnlmtcy/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  category: () => import("/Users/sebasgona/sga/pinturas-granados/granados/app/middleware/category.ts")
}